import { render, staticRenderFns } from "./ChannelPart1.vue?vue&type=template&id=8d65877a&scoped=true&"
import script from "./ChannelPart1.vue?vue&type=script&lang=js&"
export * from "./ChannelPart1.vue?vue&type=script&lang=js&"
import style0 from "./ChannelPart1.vue?vue&type=style&index=0&id=8d65877a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d65877a",
  null
  
)

export default component.exports